import { Route, Routes } from 'react-router-dom';

import { Login } from './Login';
import { InviteRequest } from './InviteRequest';
import { UpdatePassword } from '../components/UpdatePassword';
import { IntakeForm } from '@/features/intakeform/routes/intakeForm';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="invite-request" element={<InviteRequest />} />
      <Route path="/" element={<Login />} />
      <Route path="*" element={<Login />} />
      <Route path="/reset-password" element={<UpdatePassword />} />
      <Route path="/business/:slug/userform" element={<IntakeForm />} />
    </Routes>
  );
};
export * from './Login';
